import {AfterViewInit, Component, OnInit, ViewChild} from '@angular/core';
import {NavbarComponent} from './modules/navbar/navbar.component';
import {Config, SidebarComponent} from './modules/sidebar/sidebar.component';
import {MatDrawer} from '@angular/material/sidenav';
import {MercureService} from "./shared/services/mercure.service";

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent implements OnInit, AfterViewInit{

  @ViewChild(NavbarComponent) navbar: NavbarComponent;
  @ViewChild(SidebarComponent) sidebar: SidebarComponent;
  @ViewChild(MatDrawer) drawer: MatDrawer;
  leftSidenavConfigs: Array<Config> = [];

  constructor(
    private mercureService: MercureService
  ) {}

  ngOnInit(): void {
  }

  ngAfterViewInit(): void {
    this.mercureService.connect('login-lock');
  }

  toggleSidebar(): void {
    this.drawer.toggle();
  }

  changeSidebarConfig($event: Array<Config>): void {
    this.leftSidenavConfigs = $event;
  }
}
